module.exports = __webpack_public_path__ + "static/media/o_curve.b27d6bcf.svg";